<div class="home-page">
  <app-hero-slider></app-hero-slider>
  <app-about-section></app-about-section>
  <app-featured-collection [products]="showcases"></app-featured-collection>
  <app-signature-showcase></app-signature-showcase>
  <app-brand-highlights></app-brand-highlights>
  <app-cta-grid></app-cta-grid>
</div>
